import React from 'react'
import PermissionsForm from './permissions-form'
import ManageUsersForm from './manage-users-form'
import * as request from 'services/request'
import { MissingTokensIcon } from 'pages/admin/users/users'

class UserPermissions extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      user: null,
      users: []
    }

    this.selectUser = this.selectUser.bind(this)
    this.updateRole = this.updateRole.bind(this)
    this.updatePermissions = this.updatePermissions.bind(this)
    this.updateReminderLimit = this.updateReminderLimit.bind(this)
    this.save = this.save.bind(this)
    this.reset = this.reset.bind(this)
  }

  componentDidMount () {
    this.getUsers()
  }

  componentDidUpdate () {
    window.$('.selectpicker').selectpicker('refresh')
  }

  async getUsers () {
    const response = await request.authorized('/users')
    const users = await response.json()

    this.setState({ users })

    const { user } = this.state
    if (user) this.selectUser(user.id)
  }

  selectUser (id) {
    const user = this.state.users.find(u => u.id === id)
    this.setState({ user })
  }

  updateRole (role) {
    const { user } = this.state
    this.setState({
      user: {
        ...user,
        role
      }
    })
  }

  updatePermissions (included, permission) {
    const { user } = this.state

    const set = new Set(user.permissions && user.permissions.split(' '))

    if (included) set.add(permission)
    else set.delete(permission)

    const newPermissions = [...set].join(' ')

    this.setState({
      user: {
        ...user,
        permissions: newPermissions
      }
    })
  }

  updateReminderLimit (reminderLimit) {
    this.setState(({ user }) => ({
      user: {
        ...user,
        reminderLimit
      }
    }))
  }

  async save () {
    const { id, role, permissions, reminderLimit } = this.state.user

    await request.authorized(`/users/${id}`, {
      method: 'PUT',
      body: {
        role,
        permissions,
        reminderLimit
      }
    })

    this.getUsers()
  }

  reset () {
    const { user } = this.state
    if (user) this.selectUser(user.id)
  }

  render () {
    const { users } = this.state

    return (
      <div>
        <div className='row'>
          <div className='col-md-4 form-group'>
            <select
              title='Select a user'
              className='selectpicker form-control'
              data-live-search='true'
              onChange={e => this.selectUser(e.target.value)}
            >
              {users.map(user => (
                <option key={user.id} value={user.id} >
                  <div className='user-select-option'>
                    {user.screenName}
                    {
                      !user.hasTwitterTokens &&
                      <MissingTokensIcon />
                    }
                  </div>
                </option>
              ))}
            </select>
          </div>
        </div>
        {
          this.state.user ? (
            <PermissionsForm
              {...this.state.user}
              updateRole={this.updateRole}
              updatePermissions={this.updatePermissions}
              updateReminderLimit={this.updateReminderLimit}
              onSave={this.save}
              onReset={this.reset}
            />
          ) : null
        }

        {
          this.state.user
          ? <ManageUsersForm
            selectedUser={this.state.user}
            users={this.state.users}
          />
          : null
        }
      </div>
    )
  }
}

export default UserPermissions



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/user-permissions/index.js